<template>
  <el-dialog width="720px">
    <div class="receipt-dialog">
      <div class="receipt-title">确认收货</div>
      <div class="receipt-content">
        <el-form label-width="96px">
          <el-form-item label="收货备注">
            <el-input
              v-model="form.receiptRemarks"
              type="textarea"
              :rows="4"
              maxlength="200"
              show-word-limit
              placeholder="请输入收货备注"
            />
          </el-form-item>
        </el-form>
        <div class="receipt-upload">
          <div class="upload-title">上传收货回单<span>（最多上传5张，确认后完成收货）</span></div>
          <upload-file
            v-model="form.receiptFileIds"
            isType="add"
            list-type="picture-card"
            :limit="5"
            :list="fileList"
            onlyImage
            accept=".jpg,.jpeg,.png,image/jpeg,image/png"
            :maxSizeMb="2"
            @usuccess="handleUploadSuccess"
            @delete="handleUploadDelete"
          />
        </div>
      </div>
      <div class="receipt-footer">
        <el-button size="mini" @click="close">取消</el-button>
        <el-button size="mini" type="primary" @click="confirm">确认</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { ElMessage } from 'element-plus';
import uploadFile from '@/components/publicComponent/uploadFile.vue';

export default {
  components: {
    uploadFile
  },
  props: {
    oid: {
      type: String,
      default: ''
    },
    shipId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      form: {
        receiptRemarks: '',
        receiptFileIds: []
      },
      fileList: []
    };
  },
  methods: {
    ...mapActions('mysaleMudule', [
      'purchaseReceipt'
    ]),
    close() {
      this.$emit('update:modelValue', false);
      this.reset();
    },
    getFileIds(list = []) {
      return list.map(item => item.fileId || (item.data && item.data.fileId) || (item.response && item.response.data && item.response.data.fileId)).filter(Boolean);
    },
    handleUploadSuccess(info, fileList) {
      this.fileList = [...fileList];
      this.form.receiptFileIds = this.getFileIds(fileList);
    },
    handleUploadDelete(fileList) {
      this.fileList = [...fileList];
      this.form.receiptFileIds = this.getFileIds(fileList);
    },
    reset() {
      this.form = {
        receiptRemarks: '',
        receiptFileIds: []
      };
      this.fileList = [];
    },
    confirm() {
      if (!this.shipId) {
        ElMessage.warning('未获取到收货记录');
        return;
      }
      if (!this.form.receiptFileIds.length) {
        ElMessage.warning('请上传收货回单');
        return;
      }
      this.purchaseReceipt({
        documentId: this.oid,
        shipId: this.shipId,
        receiptRemarks: this.form.receiptRemarks,
        receiptFileIds: this.form.receiptFileIds
      }).then(res => {
        const { code } = res.data;
        if (code === '0') {
          ElMessage.success('确认收货成功');
          this.$emit('success');
          this.close();
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.receipt-dialog {
  padding: 20px;

  .receipt-title {
    padding-bottom: 20px;
    font-weight: bold;
  }

  .receipt-content {
    padding: 0 20px;
  }

  .receipt-upload {
    .upload-title {
      line-height: 28px;
      font-weight: bold;

      span {
        margin-left: 6px;
        font-weight: normal;
        color: #999999;
      }
    }
  }

  .receipt-footer {
    display: flex;
    justify-content: center;
    gap: 24px;
    padding-top: 20px;
  }
}
</style>
